import { Col, Row, Spin } from 'antd';
import StatisticCard from 'components/statisticCard';
import LineChart from 'components/charts/lineChart';
import { useTranslation } from 'react-i18next';
import useStatisticaProductManager from './useStatisticaProductManager';
import Filters from 'components/filters';
import BarChangeChart from '../../../../../components/charts/barChange';

const ProductStatisticsView = () => {
  const { t } = useTranslation();
  const { data, filters, loading } = useStatisticaProductManager();
  return (
    <Spin spinning={loading}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Filters hideClearAll filters={filters} />
          <br />
        </Col>
        <Col span={6}>
          <StatisticCard
            big
            count={data.product_variants_sold}
            text={t('Articoli venduti')}
          />
        </Col>
        <Col span={6}>
          <StatisticCard
            big
            count={data.product_variants_refunded}
            text={t('Articoli restituiti')}
          />
        </Col>
        <Col span={12}>
          <LineChart
            colors={['#faac18']}
            title={t('Evoluzione temporale articoli venduti')}
            tableData={data.tableData}
            data={data.lineChartData}
          />
        </Col>
        <Col span={24}>
          <BarChangeChart
            title={t('Distribuzione articoli venduti per categoria')}
            hideLegend
            keys={['Articoli venduti']}
            data={data.barChartData}
            itemWidth={130}
            translateXBar={-20}
            hideLine
            indexBy={'category'}
            colors={({ id, data }) => String(data[`${id}Color`])}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default ProductStatisticsView;
